<content>

    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm">
            <div *ngIf="filtersForm.get('pais')" [ngClass]="isSmallScreen ? (showAforos ? 'entry-5-small' : 'entry-4-small') : (showAforos ? 'entry-5' : 'entry-4')">
                <label>{{'global.pais' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="paises" 
                    (shareCheckedList)="shareCheckedListPaises($event)"
                    [selectedItem]="filtersForm.get('pais')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('denominacion')" [ngClass]="isSmallScreen ? (showAforos ? 'entry-5-small' : 'entry-4-small') : (showAforos ? 'entry-5' : 'entry-4')">
                <label>{{'central-avisos.cultivos.innerFilters.denominacion' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="denominaciones" 
                    (shareCheckedList)="shareCheckedListDenominaciones($event)"
                    [selectedItem]="filtersForm.get('denominacion')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('finca')" [ngClass]="isSmallScreen ? (showAforos ? 'entry-5-small' : 'entry-4-small') : (showAforos ? 'entry-5' : 'entry-4')">
                <label>{{'global.finca' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="fincas" 
                    (shareCheckedList)="shareCheckedListFincas($event)"
                    [selectedItem]="filtersForm.get('finca')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('productor')" [ngClass]="isSmallScreen ? (showAforos ? 'entry-5-small' : 'entry-4-small') : (showAforos ? 'entry-5' : 'entry-4')">
                <label>{{'central-avisos.cultivos.innerFilters.productor' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="productores" 
                    (shareCheckedList)="shareCheckedListProductores($event)"
                    [selectedItem]="filtersForm.get('productor')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('aforoActual')" [ngClass]="isSmallScreen ? (showAforos ? 'entry-5-small' : 'entry-4-small') : (showAforos ? 'entry-5' : 'entry-4')">
                <label>{{'central-avisos.cultivos.innerFilters.aforoActual>' | translate}}</label>
                <input type="number" formControlName="aforoActual">
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="Filtrar">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible}" (click)="filtersForm.reset()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.aplicar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>

    <div *ngIf="showCultivosSinDesignaciones" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.cultivos.cultivosSinDesignaciones.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(3)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(4)">
                        {{'central-avisos.cultivos.cultivosSinDesignaciones.productor' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string td-padding">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desFinca}}</td>
                    <td class="string-longest">{{row.desProductor}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                    <td colspan="4">
                        {{'global.noContent' | translate}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div *ngIf="showAforos" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.cultivos.aforoActualAnterior.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desFinca" (click)="toOrderBy(3)">
                        {{'global.finca' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desProductor" (click)="toOrderBy(4)">
                        {{'central-avisos.cultivos.aforoActualAnterior.productor' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="aforo" (click)="toOrderBy(5)">
                        {{'central-avisos.cultivos.aforoActualAnterior.aforoActual' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="aforo_Anterior" (click)="toOrderBy(6)">
                        {{'central-avisos.cultivos.aforoActualAnterior.aforoAnterior' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="porcentaje" (click)="toOrderBy(7)">
                        {{'central-avisos.cultivos.aforoActualAnterior.porcentaje' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(7)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string td-padding">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest td-padding">{{row.desFinca}}</td>
                    <td class="string-longest">{{row.desProductor}}</td>
                    <td class="number-longest td-padding">{{row.aforo | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number-longest">{{row.aforo_Anterior | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number">{{row.porcentaje ? (row.porcentaje | number : '1.2-2': defaultLanguage) : 0}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                    <td colspan="7">
                        {{'global.noContent' | translate}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
    <app-paginator
        *ngIf="(dataDisplayed && dataDisplayed.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>